import { createApi } from '@shared/redux/createApi';

const tags = {
  emailCampaign: 'emailCampaign',
};

const EMAIL_USER_ID = "a212f2e92b524f5dbcbeb7bef3144067";
const EMAIL_API_URL = process.env.REACT_APP_EMAIL_API_URL || 'http://54.93.191.15:8090';

export const emailCampaignApi = createApi({
  reducerPath: 'emailCampaignApi',
  tagTypes: Object.values(tags),
  endpoints: (builder) => ({
    sendEmailCampaign: builder.mutation({
      async queryFn({ subject, body, emails, onProgress }) {
        try {
          // Отправляем письмо каждому получателю отдельно
          // так получатели не видят друг друга (эквивалент BCC)
          const results = [];
          const errors = [];

          for (let index = 0; index < emails.length; index++) {
            const email = emails[index];

            try {
              const response = await fetch(`${EMAIL_API_URL}/email/send`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  email_user_id: EMAIL_USER_ID,
                  recipient_email: email,
                  subject: subject,
                  body: body
                })
              });

              if (!response.ok) {
                const errorData = await response.json();
                errors.push({ email, error: errorData.message || 'Unknown error' });
              } else {
                const data = await response.json();
                results.push({ email, success: true, data });
              }
            } catch (error) {
              errors.push({ email, error: error.message });
            }

            // Вызываем callback для обновления прогресса
            if (onProgress) {
              onProgress({
                total: emails.length,
                sent: results.length,
                failed: errors.length,
                current: index + 1,
                currentEmail: email
              });
            }
          }

          // Если все письма отправлены успешно
          if (errors.length === 0) {
            return { data: { success: true, results, sentCount: emails.length } };
          }

          // Если есть ошибки, но некоторые письма отправлены
          if (results.length > 0) {
            return {
              data: {
                success: true,
                results,
                errors,
                sentCount: results.length,
                failedCount: errors.length,
                message: `Письмо отправлено ${results.length} получателям, ${errors.length} ошибок`
              }
            };
          }

          // Если все письма не удалось отправить
          return {
            error: {
              status: 400,
              data: {
                message: `Ошибка при отправке писем`,
                errors: errors
              }
            }
          };
        } catch (error) {
          return {
            error: {
              status: 500,
              data: { message: error.message || 'Unknown error' }
            }
          };
        }
      },
      invalidatesTags: [tags.emailCampaign]
    }),
  })
});

export const {
  useSendEmailCampaignMutation,
} = emailCampaignApi;
